// Application entrypoint. Intentionally thin: every line worth testing
// lives elsewhere. main.ts only does the things that genuinely require
// a browser global — createApp, install plugins, mount.
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import App from './App.vue'
import { router } from './router'
import { queryClient } from './lib/queryClient'
import { installAuthHooks } from './stores/auth'

import './styles/main.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, { queryClient })
// Pinia must be installed before installAuthHooks runs — the hook
// calls useAuthStore() at 401 time which requires an active pinia.
installAuthHooks()
app.mount('#app')
